<template>
  <div class="jaryan-un-authorized-layout h-vh-100 row mx-0">
    <div class="right-side">
      <slot name="right" />
    </div>
    <div class="left-side">
      <div class="content">
        <slot name="left" />
      </div>
      <slot name="footer"/>
    </div>
  </div>
</template>

<script>
import SlideShow from './SlideShow.vue';
export default {
  components: { SlideShow },
  setup(_props) {},
};
</script>

<style lang="scss">

.jaryan-un-authorized-layout {
  display: flex;
  width: 100%;
  height: 100%;

  .right-side {
    display: flex;
    flex-direction: column;
    background-color: #5F2EEA;
    width: 50%;
    padding-top: 12rem;
  }

  .left-side {
    display: flex;
    flex-direction: column;
    width: 50%;

    .content {
      display: flex;
      flex-grow: 1;
      justify-content: center;
    }

    footer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1.25rem;
    }
  }

  @media screen and (max-width: 48rem) {
    .right-side {
      display: none;
    }
    footer {
      display: none !important;
    }
  }
  @media screen and (max-width: 48rem) {
    .left-side {
      width: 100%;
    }
  }

}
</style>
